import { render } from "./sample_page.vue?vue&type=template&id=f31acbd6"
import script from "./sample_page.vue?vue&type=script&lang=js"
export * from "./sample_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__